import Error403 from '@/components/403';
import { APP_ROUTES } from '@/config/routes.config';
import useAuthUser from '@/hooks/useAuthUser';
import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';

type Props = {
    children: React.ReactNode;
}
const RoleGuard: React.FC<Props> = ({ children }) => {
    const { user, hasPermission } = useAuthUser();
    const location = useLocation();

    const routeConfig = APP_ROUTES.find(route => matchPath({ path: route.path, end: true }, location.pathname));

    // If the route is not found in the routes.config, return an error 403
    if (!routeConfig) {
        console.warn(`Route ${location.pathname} not found in routes.config - access denied by default`);
        return <Error403 />;
    }

    // `public` routes are open to any authenticated user. Legacy admins (isAdmin)
    // bypass every gate. Otherwise the route must declare `requiredPermissions`
    // and the user must hold at least one of them.
    const isAllowed =
        routeConfig.public ||
        user.isAdmin ||
        (routeConfig.requiredPermissions?.length ? hasPermission(routeConfig.requiredPermissions) : false);

    if (!isAllowed) return <Error403 />;

    return <>{children}</>;
}

export default RoleGuard
